import { render, staticRenderFns } from "./socialCaptcha.vue?vue&type=template&id=316f9941&scoped=true"
import script from "./socialCaptcha.vue?vue&type=script&lang=js"
export * from "./socialCaptcha.vue?vue&type=script&lang=js"
import style0 from "./socialCaptcha.vue?vue&type=style&index=0&id=316f9941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f9941",
  null
  
)

export default component.exports